import { render, staticRenderFns } from "./BloqueExport.vue?vue&type=template&id=df18bbb8"
import script from "./BloqueExport.vue?vue&type=script&lang=js"
export * from "./BloqueExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports